import { UpPacketReworkEnd } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

/**
 * Fetch rework packets using method GET /rework
 * @param {ReworkPacketListRequest} data - the request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getReworkPackets = async (data: ReworkPacketListRequest): Promise<any> =>
    APIManager.sendGetWithBody(
        UpPacketReworkEnd.GET_REWORK,
        data,
        false,
        axios
    );
/**
 * Send rework packets using method POST /rework
 * @param {ReworkPacketConfirmationRequest} data - the request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const uploadRework = async (
    data: ReworkPacketConfirmationRequest
): Promise<any> =>
    APIManager.sendPost(
        UpPacketReworkEnd.UPLOAD_REWORK,
        data,
        false,
        {},
        {},
        axios
    );

/**
 * fetch url to sign with SAS Azure using method GET /rework/signed-url
 * @param {signedData} data - the request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const signedUrl = async (data: signedData): Promise<any> =>
    APIManager.sendGetWithBody(
        UpPacketReworkEnd.SIGNED_REWORK_RESOURCE,
        data,
        false,
        axios
    );

export const UploadPacketReworkService = {
    getReworkPackets,
    uploadRework,
    signedUrl,
};
